import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// import s from './VerifyDocument.css';
import v from '../eservices/validators';
import { DecisionContainer } from '../../containers';
import ModalAlert from '../eservices/ModalAlert';

const title = 'WODGiK - Weryfikator dokumentów cyfrowych';

const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const documentOptions = [
  {
    label: 'DOO',
    value: 'DOO',
    state: 'documentOption',
  },
  {
    label: 'LICENCJA',
    value: 'LICENCJA',
    state: 'documentOption',
  },
];

const InfoTypeDict = {
  documentOption: {
    label: 'Rodzaj dokumentu:',
    editable: true,
    type: 'Select',
    options: documentOptions,
  },

  documentName: {
    label: 'Identyfikator dokumentu:',
    editable: true,
  },
};

class VerifyDocument extends React.Component {
  state = {
    info: {
      documentOption: null,
      documentName: null,
    },
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
  }

  validators = {
    documentName: [v.NotNull],
    documentOption: [v.NotSelected],
  };

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeSelect = (e, group) => {
    const name = e.state;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      },
      () => this.validate(group, name),
    );
  }

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  onHide = () => this.setState({ showError: false });

  startVerification = () => {
    const docType = this.state.info.documentOption;
    const docName = this.state.info.documentName;

    fetch(`${process.env.API_URL}/verifyDocument/?doc_type=${docType}&doc_name=${docName}`, {
      method: 'GET',
    })
    .then(r => r.json())
    .then(resp => {
      this.verificationModal(resp.doc_found);
    });
  }

  verificationModal = (docFound) => {
    const errorTitle = 'Weryfikacja zakończona';
    let result = <p style={{ color: 'red' }}><b>NEGATYWNY</b></p>;
    if (docFound) {
      result = <p style={{ color: 'green' }}><b>POZYTYWNY</b></p>;
    }
    const errorText =
      (<div>
        <center>Weryfikacja autentyczności dokumentu przebiegła pomyślnie.</center>
        <center> Wynik weryfikacji: {result}</center>
      </div>);
    this.setState({
      errorText,
      errorTitle,
      showError: true,
    });
  }

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });
      return;
    }

    if (!hasFieldErrors) {
      this.startVerification();
    }
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {title}
        </h3>
        <DecisionContainer
          title={'Wybór dokumentu'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={InfoTypeDict}
          onChange={e => this.onChange(e, 'info')}
          onChangeSelect={e => this.onChangeSelect(e, 'info')}
        />
        <button
          type="submit-lg"
          className={'btn btn-primary'}
          style={{ float: 'right', marginRight: '15px', ...btnStyle }}
          onClick={() => this.setState({ progress: 0 }, () => this.startService())}
        >
          Uruchom
        </button>
        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
      </div>
    );
  }
}

export default VerifyDocument;




// WEBPACK FOOTER //
// src/routes/verifyDocument/VerifyDocument.js